import React from 'react'

import { ProductDisplay } from '@Domains/Product/Features/Display/Display'
import { BlockContext } from '@Globals/CMS/Context'

const ProductDisplayBlock = ({
  id,
}: {
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  return (
    <ProductDisplay
      id={id}
      presentation={presentation}
    />
  )
}

export default ProductDisplayBlock
